<template>
    <div class="reo-tip" @mouseleave="debounceHandleShow(false)" @mouseenter="debounceHandleShow(true)">
        <div class="text">
            {{ text }}
        </div>
        <popper ref="popper"
            v-model="show"
            placement='top-start'
            :offset="!isMobile?20:0"
            :visibleArrow='!isMobile'>
        </popper>
        <div ref="fly-piece"
            v-show="show"
            class="my-picker__popper"
            @mouseleave="debounceHandleShow(false)"
            @mouseenter="debounceHandleShow(true)">
            <div class="content" :style="style">
                {{ text }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import QuestionIcon from '@/common/images/common/combo/co_question.svg';
import Popper from 'element-ui/lib/utils/vue-popper.js';
import { Optimization } from '@reolink-web/utils';
import { NOOP } from '@/utils';

Popper.render = ( h ) => h( null );

const { debounce } = Optimization;

export default Vue.extend({
    props: {
        width: {
            type: [String, Number],
            default: 'auto'
        },
        text: {
            type: String
        }
    },
    components: { Popper },

    mounted (): void {

        document.getElementsByTagName( 'body' )[0].addEventListener( 'touchstart', this.touchstart );
        ( this.$refs.popper as any ).popperElm = this.$refs['fly-piece'];
        ( this.$refs.popper as any ).referenceElm = this.$el;

    },

    destroyed (): void {

        document.getElementsByTagName( 'body' )[0].removeEventListener( 'touchstart', this.touchstart );

    },

    data () {

        return {

            show: false,
            QuestionIcon,
            debounceHandleShow: NOOP as (( isShow: boolean ) => void )

        };

    },

    created() {

        this.debounceHandleShow = debounce( this.handleShow, 200 );

    },

    methods: {

        touchstart ( e ): void {

            let outSide = !Array.from( e.target.classList ).includes( 'reo-tip' ) && !e.target.closest( '.reo-tip' );
            if ( outSide && this.show ) {

                this.show = false;

            }

        },

        handleShow( isShow: boolean ) {

            this.show = isShow;

        }

    },
    computed: {

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        style (): Record<string, string> {

            let promptWidth;
            if ( this.width ) {

                promptWidth = this.width;

            } else {

                promptWidth = this.isMobile ? '6.9rem' : '3.2rem';

            }
            return {
                '--prompt-width': promptWidth
            };

        }
    }

});
</script>

<style scoped lang="less">
.reo-tip{
    position: relative;
    display: inline-flex;
    vertical-align: bottom;
    z-index: 7;
    max-width: 100%;
    min-width: 0;
    flex-shrink: 1;
}
.tip-icon{
    width: 18px;
    cursor: pointer;
    @media @mobile{
        width: 15px;
    }
}
.content{
    padding: 16px;
    box-sizing: border-box;
    background: rgba(#000, 0.8);
    max-width: 288px;
    font-size: 14px;
    /* display: none; */
    text-align: left;
    color: @font_primary_dark;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    border: 1px solid rgba(#fff, 0.07);
    border-radius: 4px;
    box-shadow: 0px 2px 10px 0px rgba(#000, 0.23);
    @media @mobile{
        font-size: 0.26rem;
    }
}
.text{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.content a{
    color: #fff;
    text-decoration: underline;
    &:hover{
        .text{
            border: none;
        }
    }
}
.content p{
    margin: 0;
}
/* .reo-tip:hover .content{
    display: block !important;
} */
.content a .ui-icon{
    transform: scale(0.5) translateY(36%);
    display: inline-block;
}
@media @mobile {
    div.content p{
        font-size: 0.24rem;
    }
}
</style>
